import { addCommas, removeCommas } from "@persian-tools/persian-tools";
// import {checkMore} from "./Financialtabs"
// datepicker
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import Select from "react-select";
import { useState } from "react";
export default function Orders({
  indexId,
  numberOfOrder,
  numberOfItems,
  dateOfOrder,
  totalPrice,
  paidPrice,
  discountPrice,
  setSelected,
  value,
  userOrder,
}) {
  function showTime(x) {
    x = x * 1000;
    const date = new DateObject({ date: x, calendar: persian });
    return date.format();
  }
  // const [orderId, setOrderId] = useState();
  return (
    <div className="orders mt-5">
      <Select
        className="w-100 mt-3"
        options={userOrder}
        onChange={(value) => {
          setSelected(value.data);
        }}
      />
      {/* <div className="form-check d-flex align-items-center ">
        <input
          className="form-check-input"
          type="radio"
          name="flexRadioDefault"
          id={indexId}
          onClick={() => {
            setSelected(value);
          }}
        />
        <div>
          <label
            className="form-check-label"
            htmlFor={indexId}
            onClick={() => {
              setSelected(value);
            }}
          >
            <div className=" d-flex flex-row flex-wrap rounded-10 shadow mt-3 mx-5">
              <div className="item flex-grow-1">
                <div
                  className="inner-item text-center bg-blue text-white p-3 fs-12 border600-1 "
                  style={{ borderRadius: "0 10px 0 0" }}
                >
                  شماره سفارش
                </div>
                <div className="inner-item text-center p-3 fs-12">
                  {numberOfOrder}
                </div>
              </div>
              <div className="item flex-grow-1">
                <div className="inner-item text-center bg-blue text-white p-3 fs-12 border1000-1">
                  تعداد آیتم ها
                </div>
                <div className="inner-item text-center p-3 fs-12 ">
                  {numberOfItems}
                </div>
              </div>
              <div className=" item flex-grow-1">
                <div className="inner-item text-center bg-blue text-white p-3 fs-12">
                  تاریخ سفارش
                </div>
                <div className="inner-item text-center p-3 fs-12">
                  {showTime(dateOfOrder)}
                </div>
              </div>
              <div className=" item flex-grow-1">
                <div className="inner-item p-3 fs-12 bg-blue text-white text-center ">
                  مبلغ کل
                </div>
                <div className="inner-item text-center p-3 fs-12">
                  {addCommas(totalPrice)} تومان
                </div>
              </div>
              <div className=" item flex-grow-1">
                <div className="inner-item p-3 fs-12 bg-blue text-white text-center ">
                  مبلغ تخفیف
                </div>
                <div className="inner-item text-center p-3 fs-12">
                  {addCommas(discountPrice)} تومان
                </div>
              </div>

              <div className="item flex-grow-1">
                <div
                  className=" inner-item p-3 fs-12 bg-blue text-white text-center border1000-2"
                  style={{ borderRadius: "10px 0 0 0" }}
                >
                  مبلغ پرداخت شده
                </div>
                <div className=" inner-item text-center  p-3 fs-12">
                  {addCommas(paidPrice)} تومان
                </div>
              </div>
            </div>
          </label>
        </div>
      </div> */}
    </div>
  );
}
